export const defaultMemberPasswordResetCreateFormEmailFieldDisplayText = {
    label: 'Email',
    requiredMessage: 'Email is required.',
    formatMessage: 'The email you entered has an invalid format.'
};
export const defaultMemberPasswordResetCreateFormUsernameFieldDisplayText = {
    label: 'Username',
    requiredMessage: 'Username is required.',
    formatMessage: 'The username you entered has an invalid format.'
};
